export default __webpack_public_path__ + "assets/images/autumn-f013c591.png";